/**
 * Component Registry for Apartment Management Consultants Theme
 * 
 * Extends the base landing-page theme registry with Apartment Management Consultants specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';
import { Hero } from './components/Hero';
import { Footer } from './components/Footer';

/**
 * Apartment Management Consultants specific component overrides.
 * These components have been customized for the Apartment Management Consultants brand.
 */
const apartmentmanagementconsultantsOverrides: Partial<ComponentRegistry> = {
  Hero,
  PageHero: Hero,
  Footer,
};

/**
 * Final merged registry for Apartment Management Consultants properties.
 * Inherits all components from the landing-page theme, with Apartment Management Consultants overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...apartmentmanagementconsultantsOverrides,
};

export default registry;
